import React, { useEffect, useState } from "react";
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, a, MDBNavbarToggler, MDBCollapse
} from "mdbreact";
import imagenActual from '../../../../paginas/img/Logo fondo blanco-03.png'
import { Bag2, Buy } from "react-iconly";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faLocation, faLocationDot, faLocationPin, faPhone, faVoicemail } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

import { Link } from "react-router-dom";
import { useValidarImagen } from "../../../hooks/useValidarImagen";

const ruta = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + 'paginas/'
const rutaImg = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + process.env.REACT_APP_IMAGENES


const MenuNavegacion = (props) => {
    const [items, setItems] = useState([])
    const [esAbierto, setEsAbierto] = useState(false)
    const { widthImg, heightImg = 40, urlImg, shadowsImg, justify = 'left', whatsappHeader = "+57xxxxxxxx", correoHeader = 'aa@gmail.com', header, textoSubMenu, backgroundSubMenu, backgroundMenu, textoMenu, instagramHeader } = props?.styles


    useEffect(() => {
        const obtenerMenu = async () => {
            try {
                const { data } = await axios(ruta, { params: { menu: true } })
                if (!data) return setItems([])
                setItems(data)
            } catch (error) {
                console.log(error)
            }
        }
        obtenerMenu()
    }, [])

    const toggleCollapse = () => {
        setEsAbierto(!esAbierto);
    }
    return (
        <div className="menu-navegacion-componente">
            {header ? <MDBNavbar dark expand="md" style={{ color: textoSubMenu, background: backgroundSubMenu }}>
                <MDBNavbarNav left >
                    <MDBNavItem className="mr-4">
                        <FontAwesomeIcon icon={faPhone} />
                        <span> {whatsappHeader}</span>
                    </MDBNavItem>
                    <MDBNavItem className="mr-4" >
                        <FontAwesomeIcon icon={faLocationDot} />
                        <span> {correoHeader}</span> <span className="font-weight-bold">{instagramHeader}</span>
                    </MDBNavItem>

                </MDBNavbarNav>

            </MDBNavbar> : null}



            <MDBNavbar className="menu-container" expand="md" style={{ background: backgroundMenu }}>
                <MDBNavbarBrand>
                    <img
                        className={`${shadowsImg && `z-depth-${shadowsImg}`}`}
                        src={useValidarImagen(urlImg)}
                        height={heightImg}
                        width={widthImg}
                    />
                </MDBNavbarBrand>
                <MDBNavbarToggler onClick={toggleCollapse} />
                <MDBCollapse id="navbarCollapse3" isOpen={esAbierto} navbar>
                    <MDBNavbarNav left={justify === 'left'} center={justify === 'center' ? 'true' : ''} right={justify === 'right'}>
                        {items && items.map(nav => (
                            <MDBNavItem key={nav.id} >
                                <Link style={{ color: textoMenu }} className="nav-link waves-effect waves-light" to={`/${nav.url}`}>{nav.nombre}</Link>
                            </MDBNavItem>
                        ))}

                    </MDBNavbarNav>
                    <div>
                        <MDBNavbarNav right >
                            <MDBNavItem >
                                <div className="carrito-compra">
                                    <Bag2 set="light" size={30} />
                                </div>
                            </MDBNavItem>
                        </MDBNavbarNav>
                    </div>

                </MDBCollapse>
            </MDBNavbar>
        </div >
    )
}

export default MenuNavegacion